import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { NgxsModule } from '@ngxs/store';
import { RegisterState } from './states/register/register-state';
import { MessageService } from 'primeng/api'; // Import MessageService
import { UserState } from './states/user/user-state';
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { MyInstituteState } from './states/myInstitutes/my-institute-state';
import { InstituteDetailState } from './states/institutedetail/institute-detail-state';
import { MenuState } from './states/menu/menu.state';
import { CustomFormsModule } from 'ngx-custom-validators';
import { provideLottieOptions,provideCacheableAnimationLoader  } from 'ngx-lottie';
import { provideClientHydration } from '@angular/platform-browser';
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes,withInMemoryScrolling({
      scrollPositionRestoration: 'top', // ✅ Automatically scrolls to top
      anchorScrolling: 'enabled', // ✅ Enables anchor scrolling if using fragment links
    })),
    provideHttpClient(
      withInterceptorsFromDi(),
      withFetch()
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true // This allows multiple interceptors
    },
    importProvidersFrom([BrowserAnimationsModule,CustomFormsModule,
      NgxsModule.forRoot([RegisterState,UserState,MyInstituteState,InstituteDetailState,MenuState])]),
    MessageService,
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideCacheableAnimationLoader(), provideClientHydration(),
   ],
};
